<!-- <app-splash-screen></app-splash-screen> -->
<ngx-spinner id="spinner"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate-pulse"
>
  <!-- <img src='./assets/media/logos/ecrin-logo-splash.jpg' class="img-fluid" alt='Logo' style='width: 215px; height: 85px; display: block; margin: auto;'> -->
  <h2 style="color: white;">Loading...</h2>
</ngx-spinner>
<router-outlet></router-outlet>
